import { useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { renderIcon } from '@/utils/iconRenderer';
import { t } from 'i18next';
import useAppApi from '@/services/api/setUserApi';
import useMessage from '@/features/hooks/useMessage';

export default function ResetPassword() {
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const passwordInputRef = useRef(null);
  const { state } = useLocation();
  const userName = state?.userName || '';
  const otp = state?.otp || '';
  const { ResetPassword } = useAppApi();
  const navigate = useNavigate();
  const { messageBox } = useMessage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!newPassword) {
      setError(t('Lütfen şifre girin'));
      passwordInputRef.current.focus();
      return;
    }

    const response = await ResetPassword({
      UserName: userName,
      Code: otp,
      NewPassword: newPassword
    });

    if (response) {
      messageBox(response.message, 'success');
      navigate('/auth/login');
    }
  };

  return (
    <div className="container mx-auto px-4 lg:px-0 lg:w-[50%] flex justify-center items-center min-h-screen">
      <div className="w-full lg:w-1/2 bg-white shadow-xl rounded-lg">
        <div className="flex items-center bg-color-primary text-white p-4 rounded-t-lg gap-2">
          {renderIcon('power-reset', 32, 'text-white')}
          <h2 className="text-lg font-medium">{t('SifreYenile')}</h2>
        </div>

        <div className="p-6">
          <form onSubmit={handleSubmit} className="space-y-4 my-3">
            <div className="flex items-center border rounded-md overflow-hidden mb-8">
              <label
                htmlFor="newPassword"
                className="px-3 text-sm text-gray-700">
                {t('YeniSifre')}
              </label>
              <input
                type="password"
                id="newPassword"
                ref={passwordInputRef}
                value={newPassword}
                onChange={(e) => {
                  setNewPassword(e.target.value);
                  setError('');
                }}
                className={`flex-1 p-2 text-gray-700 bg-gray-50 placeholder-gray-400 border-none focus:outline-none focus:ring-2 focus:ring-color-input-focus-border ${
                  error ? 'border-red-500' : ''
                }`}
                placeholder={t('YeniSifre')}
                required
              />
            </div>
            {error && <p className="text-red-500 text-sm">{error}</p>}

            <button
              type="submit"
              className="w-full flex items-center justify-center bg-color-button text-white py-2 rounded hover:bg-color-button-hover transition duration-150 ease-in-out"
              onClick={handleSubmit}>
              {renderIcon('domain-verification', 28, 'text-white mr-2')}
              <span className="text-sm">{t('SifreYenile')}</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
